// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"38":"54d63fd3","453":"f38d3b0f"}[chunkId] + ".chunk.js";
};